const BASE_URL = 'https://backend.calbarbible.com/api';

export default BASE_URL;